import Polyglot from 'node-polyglot'; // Ta biblioteka dobrze działa
import CONFIG from '../config/app';
import SessionService from './session-service';
import { flatpickr } from '../App';
import { Polish } from 'flatpickr/dist/l10n/pl';
import { Dutch } from 'flatpickr/dist/l10n/nl';
// W konsoli ustawienie `window.DEBUG_SHOW_MISSING_TRANSLATIONS = true` pokaże brakujące translacje
export class I18n {
  loaded: boolean;

  langNames: string[];

  currentLang: string | null;

  polyglot: any;

  constructor() {
    this.loaded = false;
    this.langNames = [];
    this.currentLang = null;
  }

  private _isLoaded(emitWarn = true) {
    if (!this.loaded && emitWarn) {
      console.warn('i18n not loaded!');
    }
    return this.loaded;
  }

  async load(lang: string, clb?: any) {
    const defaultLang = await fetch(
      `/assets/translations/${CONFIG.DEFAULT_LANG}.json`,
      {
        cache: 'no-cache',
      }
    );

    let i18nInfoData = await defaultLang.json();

    try {
      const response = await fetch(`/assets/translations/${lang}.json`, {
        cache: 'no-cache',
      });
      i18nInfoData = await response.json();
    } catch (err) {
      console.error(
        `Problem loading language ${lang}, using ${CONFIG.DEFAULT_LANG} fallback`
      );
    }

    // Pobranie listy języków, ale to równie dobrze może być na FE albo najlepiej jako statyczny JSON
    this.polyglot = new Polyglot({
      phrases: i18nInfoData.phrases,
      locale: i18nInfoData.locale,
      onMissingKey: (key: string) => key,
      // onMissingKey:
      //   window.DEBUG_SHOW_MISSING_TRANSLATIONS === true ? undefined : () => {}
    });
    // Tu warto wybrać język również do biblioteki czasu np. date-fns

    this.currentLang = i18nInfoData.locale;
    this.langNames = i18nInfoData.langNames;

    if (this.currentLang === 'pl') flatpickr.defaultConfig.locale = Polish;
    if (this.currentLang === 'nl') flatpickr.defaultConfig.locale = Dutch;
    if (this.currentLang === 'en') flatpickr.defaultConfig.locale = 'default';

    this.loaded = true;
    if (typeof clb === 'function') {
      clb();
    }
  }

  __(key: any, options: any) {
    if (!this._isLoaded()) return;
    return this.polyglot.t(key, options);
  }

  changeLang(newLang: any, saveInSession = true) {
    if (!this._isLoaded()) return;
    if (this.polyglot.currentLocale === newLang) return;
    if (saveInSession) SessionService.setCurrentLanguage(newLang);
    this.polyglot.locale = newLang;
    this.currentLang = newLang;
    window.location.reload(true);
    // Ja tu miałem po prostu zapisanie nowego języka i odświeżenie strony
    // Dobrze to działa, bo inaczej część tekstów byłaby stara, a nowe podmienione itp
  }
}
export const i18n = new I18n();
export const __ = (text: any, args?: any) => i18n.__(text, args);
// Użycie gdziekolwiek:
// __("Hi, my friend"); // 'Cześć, mój przyjacielu'
// __("Hi, ${name}!", { name: "Test" }); // 'Cześć, Test!'
// Więcej info: https://airbnb.io/polyglot.js/
